export default __webpack_public_path__ + "static/media/home-yellow.dcd0027e.svg";